export const objectToQueryString = (obj: Record<string, string>) => {
  return new URLSearchParams(obj as Record<string, string>).toString()
}
